/* eslint-disable indent */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import * as React from 'react';
import {
  Box,
  Typography,
  Tooltip,
  Chip,
  ListItemButton,
  ListItemText,
} from '@mui/material';
import {
  Task,
  Event,
  East,
} from '@mui/icons-material';
import NoteAlt from '@mui/icons-material/NoteAlt';
import {
  primary,
  secondary,
} from '../../../../../../../../utils/brandColors';
import { getColorForBillableStatus } from '../../../../../../../../pages/billing/components/BillablesTable';

const TaskOptionComponent = ({
  eventTemplate,
  onSelectTask,
  onSelectCalendarEvent,
}) => {
  const selectedBarn = useSelector((state) => state.barn.selectedBarn);
  const eventData = useSelector((state) => state.eventData.eventData);
  const isCalendarEvent = eventTemplate.tags.find((ett) => ett.id === selectedBarn.barnMetadata.eventTaskTypeTagId);

  const getEDNameFromId = (id) => (eventData.find((ed) => ed.id === id) || { name: 'Unknown' }).name;
  const color = (eventTemplate.eventDataDefaultValues && eventTemplate.eventDataDefaultValues.calendarDisplayColor) || primary[500];

  const metadata = (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {
          eventTemplate.eventDataDefaultValues[
          getEDNameFromId(selectedBarn.barnMetadata.horseBillablePriceEventDataId)] && (
            <Tooltip title="Billable amount at task completion">
              <Chip
                size="small"
                sx={{ mr: 1 }}
                variant="outlined"
                color={getColorForBillableStatus({ status: eventTemplate.eventDataDefaultValues['Billable Status'] || 'Open' })}
                // icon={((eventTemplate.eventDataDefaultValues['Billable Receivable'] || 'yes') === 'yes')
                //   ? <AttachMoney />
                //   : <MoneyOff />}
                label={`$${eventTemplate.eventDataDefaultValues[
                  getEDNameFromId(selectedBarn.barnMetadata.horseBillablePriceEventDataId)]}`}
              />
            </Tooltip>
          )
        }
        {
          eventTemplate.eventDataDefaultValues[
          getEDNameFromId(selectedBarn.barnMetadata.horseNoteTypeEventDataId)] && (
            <Tooltip title="Horse note to be posted along with task completion">
              <Chip
                size="small"
                icon={<NoteAlt />}
                label={`${eventTemplate.eventDataDefaultValues[getEDNameFromId(selectedBarn.barnMetadata.horseNoteTypeEventDataId)] === 'Note'
                  ? ''
                  : eventTemplate.eventDataDefaultValues[getEDNameFromId(selectedBarn.barnMetadata.horseNoteTypeEventDataId)]} Horse Note`}
              />
            </Tooltip>
          )
        }
      </Box>
      {eventTemplate.description && <Box><Typography varian="caption" sx={{ fontSize: 12 }}>{eventTemplate.description}</Typography></Box>}
    </Box>
  );
  return (
    <ListItemButton
      key={`most_used_${eventTemplate.id}`}
      dense
      onClick={() => {
        isCalendarEvent
          ? onSelectCalendarEvent(eventTemplate)
          : onSelectTask(eventTemplate)
      }}
      sx={{
        mx: 2,
        mb: 1,
        pt: 0,
        pb: 0,
        px: 1,
        backgroundColor: secondary[200],
        borderLeft: `8px solid ${color}`,
        borderRadius: 1,
      }}
    >
      <Box
        sx={{ mr: 0.5 }}
      >
        {isCalendarEvent
          ? (
            <Event
              sx={{ color: `${color} !important` }}
            />
          )
          : (
            <Task
              sx={{ color: `${color || primary[500]} !important` }}
            />
          )}
      </Box>
      <ListItemText
        primaryTypographyProps={{ component: 'div' }}
        primary={(
          <Typography
            sx={{}}
            variant="h5"
          >{eventTemplate.name}
          </Typography>
        )}
        secondaryTypographyProps={{ component: 'div' }}
        secondary={metadata}
      />
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          maxWidth: '50%',
          textAlign: 'right',
        }}
      >
        <East sx={{ ml: 2 }} color="secondary" />
      </Box>
    </ListItemButton>
  )
}

TaskOptionComponent.propTypes = {
  eventTemplate: PropTypes.object.isRequired,
  onSelectTask: PropTypes.func.isRequired,
  onSelectCalendarEvent: PropTypes.func.isRequired,
};

TaskOptionComponent.defaultProps = {};

export default TaskOptionComponent;
